export default "/images/3a2c0e087e0ae8ed3bb116ab5ac94c15.avif";